import React, { useEffect, useState } from "react"
import styled from "@emotion/styled";
import Tooltip from '@mui/material/Tooltip';
import SaveIcon from '@mui/icons-material/Save';
import ErrorIcon from "@mui/icons-material/Error";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import LeadTagDropdown from "../../../../DropDowns/LeadTagDropdown"
import MortgageTagDropdown from "../../../../DropDowns/MortgageTagDropwdown";
import { selectTeamLeadTags, selectTeamMortgageTags } from "../../../../../slices/teamAndUserSettingsSlice";
import { useAddLeadTagMutation, useUpdateMortgageTagsMutation } from "../../../../../slices/api/apiSlice";
import { selectAssignLeadTagPerm, selectAssignMortgageTagPerm } from "../../../../../slices/userActionsPermissionsSlice";
import { ErrorWrapper, InputWrapper, Button } from "../../../../../StyledComponents";

const AssignOrCreateTag = ({ leadData, userFullName, teamId, dashPerspective, userId, activeLead, mortgageData, setSaveSuccess, setIsError }) => {
  const theme = useTheme()

  const teamLeadTags = useSelector(selectTeamLeadTags)
  const teamMortgageTags = useSelector(selectTeamMortgageTags)
  const assignLeadTagPerm = useSelector(selectAssignLeadTagPerm)
  const assignMortgageTagPerm = useSelector(selectAssignMortgageTagPerm)
  
  const [addLeadTag] = useAddLeadTagMutation()
  const [updateMortgageTags] = useUpdateMortgageTagsMutation()

  const [leadSaveFetching, setLeadSaveFetching] = useState(false)
  const [mortgageSaveFetching, setMortgageSaveFetching] = useState(false)
  const [availableLeadTags, setAvailableLeadTags] = useState(teamLeadTags)
  const [availableMortgageTags, setAvailableMortgageTags] = useState(teamMortgageTags)
  const [newLeadTag, setNewLeadTag] = useState([''])
  const [newMortgageTag, setNewMortgageTag] = useState([''])
  const [showLeadAssignSave, setShowLeadAssignSave] = useState(false)
  const [showMortgageAssignSave, setShowMortgageAssignSave] = useState(false)
  const [statusLeadTagsEmpty, setStatusLeadTagsEmpty] = useState(false)
  const [statusMortgageTagEmpty, setStatusMortgageTagEmpty] = useState(false)
  const [createTag, setCreateTag] = useState(null)

  const handleSetNewLeadTag = (event) => {
    setShowLeadAssignSave(true)
    setNewLeadTag(event.target.value)
    setStatusLeadTagsEmpty(false)
  }
  const handleSetNewMortgageTag = (event) => {
    setShowMortgageAssignSave(true)
    setNewMortgageTag(event.target.value)
    setStatusMortgageTagEmpty(false)
  }

  const handleSaveNewTag = async (action, entity) => {
    setSaveSuccess(false)
    let leadId = null
    if (leadData) {
      leadId = leadData._id
    }
    let noTags = false
    if (entity === 'lead') {
      if (newLeadTag.length === 0) {
        setStatusLeadTagsEmpty(true)
        noTags = true
      }
    } else {
      if (newMortgageTag.length === 0) {
        setStatusLeadTagsEmpty(true)
        noTags = true
      }
    }
    if (!noTags && entity === 'lead') {
      setLeadSaveFetching(true)
      await addLeadTag({
        action: action,
        newTag: newLeadTag,
        userFullName: userFullName,
        leadId: leadId,
        dashPerspective: dashPerspective,
        userId: userId,
        mortgageId: mortgageData._id,
      })
      setNewLeadTag([''])
      setLeadSaveFetching(false)
      setShowLeadAssignSave(false)
    } else if (!noTags && entity === 'mortgage') {
      setMortgageSaveFetching(true)
      await updateMortgageTags({
        reqOrigin: 'lead',
        action: action,
        newTag: newMortgageTag,
        userFullName: userFullName,
        leadId: leadId,
        userId: userId,
        mortgageId: mortgageData._id,
      })
      setNewMortgageTag([''])
      setMortgageSaveFetching(false)
      setShowMortgageAssignSave(false)
    }
    setCreateTag(null)
  }

  useEffect(() => {
    let newAvailableLeadTags = [...teamLeadTags]
    if (leadData && leadData.tags) {
      for (let i = 0; i < leadData.tags.length; i++) {
        let thisTag = newAvailableLeadTags.find(tag => tag._id.toString() === leadData.tags[i].tagId.toString())
        let thisIndex = newAvailableLeadTags.indexOf(thisTag)
        newAvailableLeadTags.splice(thisIndex, 1)
      }
      setAvailableLeadTags(newAvailableLeadTags)
    }
  }, [leadData])
  useEffect(() => {
    let newAvailableMortgageTags = [...teamMortgageTags]
    if (mortgageData.tags) {
      for (let i = 0; i < mortgageData.tags.length; i++) {
        let thisTag = newAvailableMortgageTags.find(tag => tag._id.toString() === mortgageData.tags[i].tagId.toString())
        let thisIndex = newAvailableMortgageTags.indexOf(thisTag)
        newAvailableMortgageTags.splice(thisIndex, 1)
      }
    }
    setAvailableMortgageTags(newAvailableMortgageTags)
  }, [mortgageData])

  return (
    <AssignmentFooter className={createTag !== null ? 'closed open' : 'closed'}>
      <AssignmentHeader>
        <AssignmentTitle>Assign Tags</AssignmentTitle>
        <AssignmentCopy>Select from unassigned team tags and save each assignment independently.</AssignmentCopy>
      </AssignmentHeader>
      <AssignmentGrid>
        {activeLead &&
          <AssignmentCard className={((createTag === null) ? 'onDisplay' : 'hidden')}>
            <AssignmentControl>
              <AssignmentField>
                <FieldHeader>
                  <FieldLabel>Assign Lead Tag</FieldLabel>
                  <FieldStatus>
                    {statusLeadTagsEmpty === true && (
                      <ErrorWrapper>
                        <ErrorIcon />
                        Select a tag
                      </ErrorWrapper>
                    )}
                  </FieldStatus>
                </FieldHeader>
                <LeadTagDropdown
                  value={newLeadTag}
                  handleChange={handleSetNewLeadTag}
                  items={availableLeadTags}
                  disabled={!assignLeadTagPerm}
                />
              </AssignmentField>
              {showLeadAssignSave ?
                <Tooltip
                  componentsProps={{tooltip: {sx: {
                    color: `${theme.tooltip.label.color}`,
                    backgroundColor: `${theme.tooltip.label.background}`,
                    border: `0.1rem solid ${theme.tooltip.label.border}`,
                    borderBottom: `0.1rem solid ${theme.tooltip.label.border}`,
                    opacity: '0',
                    borderRadius: '1rem',
                    width: 'fit-content',
                    minWidth: 'fit-content',
                    padding: '0.5rem 1rem',
                  }}}}
                  PopperProps={{modifiers: [{
                    name: "offset",
                    options: {
                      offset: [0, 0],
                    },
                  }]}}
                  title={newLeadTag.length > 0 && assignLeadTagPerm ?
                    <TooltipText>Save</TooltipText>
                  : !assignLeadTagPerm || leadSaveFetching ?
                    null
                  :
                    <TooltipText>No Lead Tags Selected</TooltipText>
                  } 
                  placement="top"
                  arrow
                >
                  <Button 
                    onClick={(!leadSaveFetching && assignLeadTagPerm) ? () => handleSaveNewTag('add', 'lead') : null}
                    className={!assignLeadTagPerm ? "primaryDisabled notes"  : leadSaveFetching ? "primaryLoading notes" : "primary notes"}
                  >
                    <SaveIcon />
                  </Button>
                </Tooltip>
              :
                <ActionSpacer />
              }
            </AssignmentControl>
          </AssignmentCard>
        }
        <AssignmentCard className={((createTag === null) ? 'onDisplay' : 'hidden')}>
          <AssignmentControl>
            <AssignmentField>
              <FieldHeader>
                <FieldLabel>Assign Mortgage Tag</FieldLabel>
                <FieldStatus>
                  {statusMortgageTagEmpty === true && (
                    <ErrorWrapper>
                      <ErrorIcon />
                      Select a tag
                    </ErrorWrapper>
                  )}
                </FieldStatus>
              </FieldHeader>
              <MortgageTagDropdown
                value={newMortgageTag}
                handleChange={handleSetNewMortgageTag}
                items={availableMortgageTags}
                disabled={!assignMortgageTagPerm}
              />
            </AssignmentField>
            {showMortgageAssignSave ?
              <Tooltip
                componentsProps={{tooltip: {sx: {
                  color: `${theme.tooltip.label.color}`,
                  backgroundColor: `${theme.tooltip.label.background}`,
                  border: `0.1rem solid ${theme.tooltip.label.border}`,
                  borderBottom: `0.1rem solid ${theme.tooltip.label.border}`,
                  opacity: '0',
                  borderRadius: '1rem',
                  width: 'fit-content',
                  minWidth: 'fit-content',
                  padding: '0.5rem 1rem',
                }}}}
                PopperProps={{modifiers: [{
                  name: "offset",
                  options: {
                    offset: [0, 0],
                  },
                }]}}
                title={newMortgageTag.length > 0 && assignMortgageTagPerm ?
                  <TooltipText>Save</TooltipText>
                : !assignMortgageTagPerm || mortgageSaveFetching ?
                  null
                :
                  <TooltipText>No Mortgage Tags Selected</TooltipText>
                } 
                placement="top"
                arrow
              >
                <Button 
                  onClick={(!mortgageSaveFetching && assignMortgageTagPerm) ? () => handleSaveNewTag('add', 'mortgage') : null}
                  className={!assignMortgageTagPerm ? "primaryDisabled notes"  : mortgageSaveFetching ? "primaryLoading notes" : "primary notes"}
                >
                  <SaveIcon />
                </Button>
              </Tooltip>
            :
              <ActionSpacer />
            }
          </AssignmentControl>
        </AssignmentCard>
      </AssignmentGrid>
    </AssignmentFooter>
  )
}

const AssignmentFooter = styled.footer(({ theme }) => `
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(12rem, 0.6fr) minmax(0, 1.4fr);
  gap: 1rem;
  align-items: center;
  padding: 0.9rem 1rem;
  border-top: 0.1rem solid ${theme.palette.common.grayBorder};
  background: ${theme.palette.common.white};
`)

const AssignmentHeader = styled.div`
  display: grid;
  gap: 0.25rem;
`

const AssignmentTitle = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 0.95rem;
  font-weight: 800;
  text-transform: uppercase;
`)

const AssignmentCopy = styled.div(({ theme }) => `
  color: ${theme.palette.common.grayText};
  font-size: 0.85rem;
  font-weight: 600;
  line-height: 1.35;
`)

const AssignmentGrid = styled.div`
  min-width: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
  gap: 0.8rem;
`

const AssignmentCard = styled.div(({ theme }) => `
  min-width: 0;
  padding: 0.75rem;
  border: 0.1rem solid ${theme.palette.common.grayBorder};
  border-radius: 0.8rem;
  background: ${theme.palette.common.cardBackground};
`)

const AssignmentControl = styled.div`
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 3rem;
  gap: 0.6rem;
  align-items: end;
`

const AssignmentField = styled(InputWrapper)`
  width: 100%;
  min-width: 0;
  margin: 0;
  align-items: stretch;
`

const FieldHeader = styled.div`
  min-height: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
`

const FieldLabel = styled.div(({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: 0.85rem;
  font-weight: 800;
  white-space: nowrap;
`)

const FieldStatus = styled.div`
  min-width: 0;
  display: flex;
  justify-content: flex-end;
`

const ActionSpacer = styled.div`
  width: 3rem;
  min-width: 3rem;
  max-width: 3rem;
`

const TooltipText = styled.span`
  padding: 0;
  margin: 0;
  font-weight: 600;
`

export default AssignOrCreateTag
